<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Laboratories</h4>
                    <div class="card-body text-justify">
                        <p class="text-justify inner-lead">Children are the fore-runners of a country and MPPS strives to nurture the best in them by tapping their potential in the most agreeable ambience. We firmly believe that a good lab not only makes science experiments fun but also help students achieve good academic results.</p>
                       <p class="inner-lead">We firmly believe that a good lab not only makes science experiments fun but also help students achieve good academic results.</p>
                        <p class="inner-lead font-weight-bold">We have fully equipped state-of-the-art labs for <br> Physics, <br> Chemistry, <br> Biology & <br> Maths. <br> Children are regularly taken to the labs in groups. All the students, thus, get ample opportunities to understand the theoretical concepts by doing things practically.</p>
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/1.jpg" data-lightbox="Chemistry"><img src="/assets/img/campus/labs/1.jpg" alt="Chemistry" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Chemistry</h5>
                            </div>
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/2.jpeg" data-lightbox="Physics"><img src="/assets/img/campus/labs/2.jpeg" alt="Physics" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Physics</h5>
                          </div>
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/3.jpeg" data-lightbox="Biology"><img src="/assets/img/campus/labs/3.jpeg" alt="Biology" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Biology</h5>
                            </div>
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/4.jpg" data-lightbox="Maths"><img src="/assets/img/campus/labs/4.jpg" alt="Maths" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Maths</h5>
                            </div>
                        </div>
                            <!-- <div id="labs" class="carousel slide" data-ride="carousel">
                              <div class="carousel-indicators">
                                <button type="button" data-bs-target="#labs" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                                attr.data-bs-slide-to="{{i}}"></button>
                              </div>
                                <div class="carousel-inner text-center py-5 px-3">
                                  <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                                    <a appLazyload href="{{img}}" data-lightbox="Labs"><img appLazyload [src]="img" alt="Labs" class="img-fluid rounded"></a>
                                  </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#labs" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#labs" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div> -->
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>